<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="addIntegration($event)"
    [description]="widgetRef.widgetDescription"
></app-integration>
